module.exports = __webpack_public_path__ + "static/media/lisa.b14e1f52.png";